module.exports = __webpack_public_path__ + "img/GEORGIA-V-CW.0fa2e998.svg";